<template>
    <div class="quick-actions-separator">
        <div class="quick-actions-separator__line" />
    </div>
</template>

<style scoped lang="scss">
.quick-actions-separator {
    display: flex;
    align-items: center;
    width: 100%;
    padding: var(--spacing-xxs, 2px) 0;
    flex: 1 0 0;
    min-height: 1px;

    &__line {
        width: 100%;
        height: 1px;
        background-color: var(--stroke-soft-200, #dbdfe6);
        flex: 1 0 0;
    }
}
</style>
